import React from "react";

// Components
import {FormPageLayout} from "../../components/layout/FormPageLayout";
import {UserTermsFeature} from "../../features/userTerms";

const UserTermsPage = () => (
  <FormPageLayout
    body={
      <UserTermsFeature />
    }
  />
)

export default UserTermsPage;
